import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService, EventManager } from 'ng-jhipster';
import { CardType } from './card-type.model';
import { CardTypeService } from './card-type.service';
import {  CARD_UNLIMITED_BOOKINGS_NUMBER} from '../../shared';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'jhi-card-type-detail',
    templateUrl: './card-type-detail.component.html'
})
export class CardTypeDetailComponent implements OnInit, OnDestroy {

    cardType: CardType;
    private subscription: any;
    private cardTypeSubscription: Subscription;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private cardTypeService: CardTypeService,
        private eventManager: EventManager,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['cardType']);
    }

    getMaxAssistances() {
        return CARD_UNLIMITED_BOOKINGS_NUMBER;
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
        this.cardTypeSubscription = this.eventManager
        .subscribe('cardTypeListModification',
        (response) => {
            this.cardType = response['content']['content'];
        });
    }

    load(id) {
        this.cardTypeService.find(id).subscribe(cardType => {
            this.cardType = cardType;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.cardTypeSubscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/card-type/card-type-detail.component.ts